/**
 * Shared layout helpers for the two radar charts (SeverityRadar, NatSecRadar).
 *
 * ECharts forces `overflow: 'truncate'` on radar axis names (AxisBuilder), so
 * `axisName.width` / `overflow: 'break'` never wrap them. Wrapping is done by
 * the formatter instead, and the radius is capped from the container width so
 * the longest name still fits beside the polygon on a phone.
 */

/** Break a name into lines of at most `maxChars`, at spaces (and after "/"). */
export function wrapAxisName(name: string, maxChars = 13): string {
  const words = name.replace(/\s*\/\s*/g, ' / ').split(/\s+/);
  const lines: string[] = [];
  let line = '';
  for (const w of words) {
    const next = line ? `${line} ${w}` : w;
    if (line && next.length > maxChars) {
      lines.push(line);
      line = w;
    } else {
      line = next;
    }
  }
  if (line) lines.push(line);
  return lines.join('\n');
}

/**
 * Radius in px for a radar in a `width` x `height` box: the usual fraction of
 * the box, but never so large that `labelAllowance` px of name on each side
 * would run off the canvas.
 */
export function radarRadius(width: number, height: number, fraction: number, labelAllowance: number): number {
  const byBox = (fraction * Math.min(width, height)) / 2;
  const byWidth = width / 2 - labelAllowance;
  return Math.max(48, Math.min(byBox, byWidth));
}
